import {defineMessages} from "@project/i18n";

export const materialDetailMessages = defineMessages({
  materialContentSections: {
    id: "engineering.materials.detail.sections",
    defaultMessage: "Material content sections",
    description: "Accessible label for material detail tabs",
  },
  overview: {
    id: "engineering.materials.detail.overview",
    defaultMessage: "Overview",
    description: "Overview tab label for material detail",
  },
  overviewActions: {
    id: "engineering.materials.detail.overviewActions",
    defaultMessage: "Material overview actions",
    description: "Accessible label for material overview actions",
  },
  selectView: {
    id: "engineering.materials.detail.selectView",
    defaultMessage: "Select material view",
    description: "Accessible label for mobile material detail view switcher",
  },
  viewCurrent: {
    id: "engineering.materials.detail.viewCurrent",
    defaultMessage: "View: {view}",
    description: "Current mobile material detail section label",
  },
  manageFunctions: {
    id: "engineering.materials.detail.functions.manage",
    defaultMessage: "Manage functions",
    description: "Open Material Function assignment manager",
  },
  noAssignedFunctions: {
    id: "engineering.materials.detail.functions.empty",
    defaultMessage: "No functions assigned",
    description: "Empty Material Function assignment summary",
  },
  assignFunction: {
    id: "engineering.materials.detail.functions.assign",
    defaultMessage: "Assign function",
    description: "Material Function assignment action",
  },
  removeFunction: {
    id: "engineering.materials.detail.functions.remove",
    defaultMessage: "Unassign {name} from material",
    description: "Material Function unassignment label",
  },
  remove: {
    id: "engineering.materials.detail.functions.removeAction",
    defaultMessage: "Unassign",
    description: "Remove Material Function assignment",
  },
  selectFunction: {
    id: "engineering.materials.detail.functions.select",
    defaultMessage: "Material function",
    description: "Material Function picker label",
  },
  alreadyAssigned: {
    id: "engineering.materials.detail.functions.alreadyAssigned",
    defaultMessage: "Function already assigned",
    description: "Selected Material Function already assigned",
  },
  doneManagingFunctions: {
    id: "engineering.materials.detail.functions.done",
    defaultMessage: "Done",
    description: "Close Material Function manager",
  },
  updatingFunctions: {
    id: "engineering.materials.detail.functions.updating",
    defaultMessage: "Updating functions…",
    description: "Material Function mutation progress",
  },
  failedManagingFunctions: {
    id: "engineering.materials.detail.functions.manageFailed",
    defaultMessage: "Could not update functions",
    description: "Material Function manager failure",
  },
  assignmentTitle: {
    id: "engineering.materials.detail.functions.assignmentTitle",
    defaultMessage: "Assign material function",
    description: "Material Function assignment modal title",
  },
  unassignmentTitle: {
    id: "engineering.materials.detail.functions.unassignmentTitle",
    defaultMessage: "Unassign material function",
    description: "Material Function unassignment modal title",
  },
  confirmUnassignment: {
    id: "engineering.materials.detail.functions.confirmUnassignment",
    defaultMessage: "Unassign {name} from this material?",
    description: "Confirm removing Material Function assignment",
  },
  cancelAssignment: {
    id: "engineering.materials.detail.functions.cancel",
    defaultMessage: "Cancel",
    description: "Dismiss Material Function assignment modal",
  },
  assignedFunction: {
    id: "engineering.materials.detail.functions.assigned",
    defaultMessage: "Function assigned",
    description: "Material Function assignment success",
  },
  failedAssignFunction: {
    id: "engineering.materials.detail.functions.failedAssign",
    defaultMessage: "Could not assign function",
    description: "Material Function assignment failure",
  },
  removedFunction: {
    id: "engineering.materials.detail.functions.removed",
    defaultMessage: "Function unassigned",
    description: "Material Function unassignment success",
  },
  failedRemoveFunction: {
    id: "engineering.materials.detail.functions.failedRemove",
    defaultMessage: "Could not unassign function",
    description: "Material Function unassignment failure",
  },
  composition: {
    id: "engineering.materials.detail.composition",
    defaultMessage: "Composition",
    description: "Composite Material components tab",
  },
  compositionUnavailable: {
    id: "engineering.materials.detail.composition.unavailable",
    defaultMessage: "Composition is available only for composite materials.",
    description: "SIMPLE Material direct-route unavailable state",
  },
  componentsUnavailable: {
    id: "engineering.materials.detail.composition.componentsUnavailable",
    defaultMessage: "Component details are unavailable.",
    description: "Composite Material missing direct-component projection",
  },
  backToMaterials: {
    id: "engineering.materials.detail.composition.back",
    defaultMessage: "Back to materials",
    description: "Return to Materials collection from unavailable composition",
  },
  componentKind: {
    id: "engineering.materials.detail.composition.kind",
    defaultMessage: "Kind",
    description: "Component Catalog Item kind column",
  },
  componentName: {
    id: "engineering.materials.detail.composition.name",
    defaultMessage: "Component",
    description: "Component Catalog Item name/code column",
  },
  componentQuantity: {
    id: "engineering.materials.detail.composition.quantity",
    defaultMessage: "Quantity",
    description: "Direct component quantity column",
  },
  componentUnit: {
    id: "engineering.materials.detail.composition.unit",
    defaultMessage: "Unit",
    description: "Material unit or Service billing unit column",
  },
  componentState: {
    id: "engineering.materials.detail.composition.state",
    defaultMessage: "State",
    description: "Component lifecycle column",
  },
  componentSupply: {
    id: "engineering.materials.detail.composition.supply",
    defaultMessage: "Supply",
    description: "Component derived supply status column",
  },
  serviceKind: {
    id: "engineering.materials.detail.composition.service",
    defaultMessage: "Service",
    description: "Service component kind",
  },
  materialKind: {
    id: "engineering.materials.detail.composition.material",
    defaultMessage: "Material",
    description: "Material component kind",
  },
  missingOfferDescriptionsTitle: {
    id: "engineering.materials.detail.missingOfferDescriptions.title",
    defaultMessage: "Incomplete offer descriptions",
    description: "Title shown when a material has fewer than 3 offer descriptions",
  },
  missingOfferDescriptionsDescription: {
    id: "engineering.materials.detail.missingOfferDescriptions.description",
    defaultMessage: "Add the missing offer description(s): {languages}.",
    description:
      "Description shown when a material has fewer than 3 offer descriptions. {languages} lists the missing language codes",
  },
});
